import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";

import CustomNavbar from "../../components/CustomNavbar";
import CustomFooter from "../../components/CustomFooter";
import ShowInfo from "../../components/ShowInfo";
import MainContentSpaced from "../../components/MainContentSpaced";

import api from "../../service/api";
import { TOKEN_USERTYPE, TOKEN_BRANCHID } from "../../service/tokens";

const AdCreate = (props) => {
    const [showTrips, setShowTrips] = useState(true);
    const [showAlert, setShowAlert] = useState(false);
    const [alertTitle, setAlertTitle] = useState("");
    const [alertText, setAlertText] = useState("");
    const [alertVariant, setAlertVariant] = useState("");
    const [branches, setBranches] = useState([]);
    const [adName, setAdName] = useState(null);
    const [adLink, setAdLink] = useState(null);
    const [branchSelected, setBranchSelected] = useState(null);
    const [file, setFile] = useState(null);
    const [showBranches, setShowBranches] = useState(false);

    useEffect(
        function () {
            async function getBranches() {
                const responseGetBranches = await api.get("/branch");
                if (responseGetBranches.data.error) {
                    alert("Erro ao buscar os CPFs. Contate o suporte!");
                    setTimeout(function () {
                        props.history.push("/dashboard");
                    }, 2000);
                } else {
                    setBranches(responseGetBranches.data.data);
                    setShowBranches(true);
                }
            }

            const userType = Number(
                window.localStorage.getItem(TOKEN_USERTYPE)
            );
            const branchId = Number(
                window.localStorage.getItem(TOKEN_BRANCHID)
            );
            if (userType === 1) {
                setBranchSelected(branchId);
                setShowBranches(false);
            } else {
                getBranches();
            }
        },
        [props.history]
    );

    function handleSubmit(e) {
        e.preventDefault();

        const formData = new FormData();
        formData.append("image_ad", file);
        formData.append("name", adName);
        if (adLink !== null) {
            formData.append("link", adLink);
        }
        formData.append("branch", branchSelected);

        async function postAdCreate() {
            const responsePostAdCreate = await api.post("/ad", formData);

            if (
                responsePostAdCreate.data.error ||
                responsePostAdCreate.status === 500
            ) {
                setShowAlert(true);
                setAlertTitle("Problemas ao criar o anúncio.");
                setAlertText(
                    `Tivemos problemas ao tentar criar o anúncio para a empresa selecionada. Por favor contate o suporte!`
                );
                setAlertVariant("danger");
            } else {
                setShowAlert(true);
                setAlertTitle("Anúncio criado com sucesso!");
                setAlertText(
                    `Voce sera automaticamente direcionado para a lista`
                );
                setAlertVariant("success");

                setTimeout(() => {
                    props.history.push("/ad-list");
                }, 5000);
            }
        }

        postAdCreate();
    }

    return (
        <>
            <CustomNavbar />
            <MainContentSpaced>
                <Container>
                    <Row>
                        <Col>
                            <ShowInfo
                                title={alertTitle}
                                text={alertText}
                                show={showAlert}
                                variant={alertVariant}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form onSubmit={handleSubmit}>
                                <Form.Group controlId="formAd">
                                    <Form.Label>Nome Anúncio</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Nome Anúncio"
                                        value={adName}
                                        onChange={(e) => {
                                            setAdName(e.target.value);
                                        }}
                                    />
                                    <Form.Text className="text-muted">
                                        Digite o nome desejado para o Anúncio.
                                    </Form.Text>
                                </Form.Group>

                                <Form.Group controlId="formAd">
                                    <Form.Label>
                                        Link Anúncio (opcional)
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Link Anúncio"
                                        value={adLink}
                                        onChange={(e) => {
                                            setAdLink(e.target.value);
                                        }}
                                    />
                                    <Form.Text className="text-muted">
                                        Digite o link desejado para o Anúncio.
                                    </Form.Text>
                                </Form.Group>

                                {showBranches ? (
                                    <Form.Group controlId="formCNPJ">
                                        <Form.Label>Empresa</Form.Label>
                                        <Form.Control
                                            as="select"
                                            value={branchSelected}
                                            onChange={(e) => {
                                                setBranchSelected(
                                                    e.target.value
                                                );
                                            }}
                                        >
                                            <option>Escolha...</option>
                                            {branches.map((item, index) => (
                                                <option
                                                    value={item.id}
                                                >{`${item.cnpj} - ${item.email}`}</option>
                                            ))}
                                        </Form.Control>
                                    </Form.Group>
                                ) : null}

                                <Form.Group controlId="formFile">
                                    <Form.Label>Imagem</Form.Label>
                                    <Form.Control
                                        type="file"
                                        onChange={(e) => {
                                            setFile(e.target.files[0]);
                                        }}
                                    />
                                    <Form.Text className="text-muted">
                                        Escolha a imagem correta de fundo.
                                    </Form.Text>
                                </Form.Group>

                                <Button variant="success" type="submit">
                                    Criar!
                                </Button>
                            </Form>
                        </Col>
                        {showTrips ? (
                            <Col>
                                <Card>
                                    <Card.Header>Dicas</Card.Header>
                                    <Card.Body>
                                        <Card.Title>
                                            Use essas dicas durante o cadastro:
                                        </Card.Title>
                                        <Card.Text>
                                            <ul className="list-unstyled">
                                                <li>
                                                    - Digite o nome desejado
                                                    para a Campanha
                                                </li>
                                                <li>
                                                    - Verifique se o CNPJ da
                                                    Empresa esta correto.
                                                </li>
                                            </ul>
                                        </Card.Text>
                                        <Button
                                            variant="warning"
                                            onClick={() => setShowTrips(false)}
                                        >
                                            Não quero mais ver as dicas!
                                        </Button>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ) : null}
                    </Row>
                </Container>
            </MainContentSpaced>
            <CustomFooter />
        </>
    );
};

export default withRouter(AdCreate);
